<div class="row justify-content-evenly py-5 bg-gray">
  <div class="col-12 text-center">
    <p class="fs-4 fw-bold">
      {{ "Subscribe now to one of our packages" | translate }}
    </p>
  </div>
  <div class="col-md-12 mt-2 mb-5 text-center">
    <p class="fs-6 fw-bold gray_color">
      {{
        "Subscribe to one of our packages and enjoy our special services"
          | translate
      }}
    </p>
  </div>
  <div
    *ngFor="let package of packages"
    class="col-lg-3 col-md-5 col-10 card_body text-center report_section pt-5 border rounded-3 mb-5"
  >
    <div class="row position-relative">
      <span class="side_Style"></span>
      <div class="col-md-4 float-right fs-6 my-3">
        <p class="m-0 text-uppercase">
          {{ package.type }}
        </p>
      </div>
      <div
        class="col-md-12 text-left fs-3 mr-3 ml-3 fw-bold price"
        style="color: #d02f75"
      >
        <p class="m-0">
          {{ package.price | currency }}
        </p>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 d-flex justify-content-end gap-2 b-3 section_title">
        <h3 class="m-0">
          <i class="fa fa-check" style="color: #d02f75"></i>
          {{ package.description }}
        </h3>
      </div>
      <div class="col-md-12">
        <ul class="report_list">
          <li
            *ngFor="let feature of package.features"
            class="d-flex gap-2 overflow-hidden mb-2 justify-content-end"
          >
            <div class="half-circle"></div>
            <p class="m-0 lh-lg">
              {{ feature }}
            </p>
          </li>
        </ul>
        <div class="row mt-4 justify-content-center">
          <button class="btn bv mb-5 text-white rounded-pill w-75">
            {{"subscribe now" | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
